module.exports = __webpack_public_path__ + "img/icon-tel.7c533914.svg";